<template>
  <drawer title="详情" :visible="visible" width="600px" @close="close">
    <el-form>
      <el-form-item label="ID">
        {{ detail.id }}
      </el-form-item>
      <el-form-item label="部署平台">
        {{ PIPELINE_PLATFORM[detail.app_type] }}
      </el-form-item>
      <el-form-item label="构建环境">
        {{ PIPELINE_ENV[detail.env] }}
      </el-form-item>
      <template v-if="tab === 'mini'">
        <el-form-item label="小程序ID">
          {{ detail.mini_appid }}
        </el-form-item>
        <el-form-item label="小程序分支">
          {{ detail.mini_branch }}
        </el-form-item>
      </template>
      <el-form-item label="定制分支">
        {{ detail.custom_branch }}
      </el-form-item>
      <el-form-item label="制品地址号">
        {{ detail.artifact_url }}
      </el-form-item>
      <el-form-item label="备注">
        {{ detail.remark }}
      </el-form-item>
      <el-form-item label="构建日志">
        {{ detail.build_detail }}
      </el-form-item>
    </el-form>
    <template v-slot:footer>
      <el-button type="info" @click="close">关闭</el-button>
    </template>
  </drawer>
</template>

<script>
import drawer from 'nges-common/src/web/components/drawer/index.vue';
import { PIPELINE_PLATFORM, PIPELINE_ENV } from '@/utils/constant.js';

export default {
  components: { drawer },
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    detail: {
      type: Object,
      default: () => {},
    },
    tab: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      PIPELINE_PLATFORM,
      PIPELINE_ENV,
    };
  },
  methods: {
    close() {
      this.$emit('close');
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/styles/element/input.scss';
@import '@/styles/element/form.scss';
@import '@/styles/element/button.scss';
</style>
